module.exports = __webpack_public_path__ + "img/card_2.b79050a0.svg";